<template>
  <div class="navbar fs-sm d-center">
    <div class="navbar-content j-flex">
      <div class="navbar-each home" @click="backToHome()">
        <!-- <img src="../../assets/img/home.svg" /> -->
        <div class="home-img"></div>
      </div>
      <div class="navbar-each" v-for="item in navData" :key="item.id">
        <div class="navbar-each-name" @click="changePage(item.href)">
          {{ item.name }}
        </div>
        <ul>
          <li
            v-for="each in item.child"
            :key="each.id"
            @click.stop="changePageLi(each.href, item, each)"
          >
            {{ each.title }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import navigationData from '../../assets/js/navData'
export default {
  data() {
    return {
      navData: [],
    }
  },
  created() {
    this.navData = navigationData
  },
  methods: {
    backToHome() {
      this.$router.push('/index')
    },
    changePage() {
      //   this.$router.push(path)
    },
    changePageLi(path, item, each) {
      this.$store.commit('setCurrNavNum', each.id)
      //   let mypath = ''
      //   if (each.href == '/video') {
      //     mypath = '/teaching'
      //   } else {
      //     mypath = each.href
      //   }
      let currindex = each.id
      if (each.title == '教学教材' || each.title == '教学视频') {
        currindex = 0
      }
      this.$router.push({
        path,
        query: {
          one: item.name,
          two: each.title,
          three: '',
          path: '/teaching',
          path1: '/teaching',
          //   path2: each.href,
          //   oneInfo: { name: item.name, path: item.href },
          //   twoInfo: { name: each.title, path: each.href },
          //   threeInfo: { name: '', path: '' },
          keepalive: currindex,
          keepchild: 0,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/main.scss';
.navbar {
  width: 100%;
  min-width: 1100px;
  height: 49px;
  background-color: $darkGrenn;
  box-shadow: inset 0px 1px 0px #4da282;
}
.navbar-each {
  width: 88px;
  text-align: center;
  color: $white;
  cursor: pointer;
  position: relative;
  ul {
    display: none;
    position: absolute;
    z-index: 9;
    width: 72px;
    top: 35px;
    padding: 4px 8px 8px 8px;
    background: linear-gradient(180deg, #339571 0%, #1a875f 100%);
    li {
      list-style: none;
      width: 100%;
      text-align: left;
      margin-left: 6px;
      line-height: 20px;
      padding-top: 8px;
      &:hover {
        color: $hoverColor;
      }
    }
  }
  &:hover {
    .navbar-each-name {
      color: $hoverColor;
      background: linear-gradient(180deg, #339571 0%, #1a875f 100%);
      box-shadow: inset 0px 2px 0px #ffb612;
    }
    ul {
      display: block;
    }
  }
}
.navbar-each-name {
  width: 88px;
  height: 49px;
  line-height: 49px;
}
.navbar-content {
  width: 1100px;
}
.home {
  width: 49px;
  margin-left: 10px;
  padding-top: 5px;
  height: 44px;
  line-height: 49px;

  .home-img {
    background: url('../../assets/img/home.svg');
    background-repeat: no-repeat;
    background-size: 18px;
    background-position: center;
    width: 100%;
    height: 100%;
    margin-top: -2px;
  }
  &:hover {
    background: linear-gradient(180deg, #339571 0%, #1a875f 100%);
    box-shadow: inset 0px 2px 0px #ffb612;
    .home-img {
      background: url('../../assets/img/home2.svg');
      background-repeat: no-repeat;
      background-size: 18px;
      background-position: center;
      width: 100%;
      height: 100%;
    }
  }
}
.home2 {
  background: url('../../assets/img/home2.svg');
}
</style>
